'use client';

import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import Image from 'next/image';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

export const QRCodeApp = () => {
  const [qr, setQr] = useState('');

  useEffect(() => {
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/api/redirect/app`;

    QRCode.toDataURL(url)
      .then(setQr);
  }, []);

  return (
    <>
      {qr && (
        <Image
          data-testid={DataTestIdEnum.CITY_DOWNLOAD_APP_SECTION_QR_CODE}
          src={qr}
          alt="QR Code para instalar o app"
          width={171}
          height={170}
          draggable={false}
          className="border border-gray-300 rounded-md"
        />
      )}
    </>
  );
};
